<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         :closeOnBackdrop="false"
         :show.sync="show"
      >
         <h6> Do you really want to publish this schedule ? </h6>
                 <CInput :value="(form.id)" disabled hidden />
                <CInput :value="(form.status)" disabled hidden  />
         <template #footer>
            <CButton
               style="width:200px"
               color="success"
               block
               v-on:click.prevent="publish(form.id,form.status)"
               type="submit"
               >Publish</CButton
            >
            <CButton @click="show = false" color="danger">Close</CButton>
         </template>
         <!-- <pre>{{ $data | json }}</pre> -->
      </CModal>
   </form>
</template>

<script>
import EventBus from "@/eventBus";
import classschedule from "@/services/class_schedule";

export default {
   name: "peoplemodal",

   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         form: {
            id: "",
            status: "2",
         },
      };
   },
   computed: {},
   mounted() {},
   created() {
      var self = this;
      EventBus.$on("OPEN_SHOW_PUBLISH", (params) => {
         if (params.data) {
            classschedule
               .getSchedulebyID(params.data)
               .then((res) => {
                  console.log(params, "params");
                  console.log(res, "data");
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.id = params.data;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.id = "";
            self.form.status = "2";
         }
      });
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      publish(id){
         this.show = false;
        classschedule.setPublish(id,this.form)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      
    },
      
   },
};
</script>
